export const dynamicForm = {
  "statusCode": 200,
  "isSuccess": true,
  "data": {
      "admissionFormId": 7,
      "unvId": 99,
      "categoryId": 334,
      "admissionFormName": "Under Graduate Degree  Programme - DA",
      "description": "Under Graduate Degree  Programme - DA",
      "preRequisite": "",
      "isActive": 1,
      "lastActiveSection": 0,
      "enquiryId": 1095462,
      "admissionId": 0,
      "sections": [
          {
              "sectionId": 12,
              "sectionName": "Compulsory Subjects",
              "isActive": 1,
              "sequence": 1,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 11,
              "fieldsList": [
                  {
                      "sectionId": 12,
                      "fieldId": 73,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "OBCA-122 - Accounting and Financial Management",
                      "dbColumnName": "SubjectId",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "10813",
                      "fieldDataSourceType": "SubjectId",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Label",
                      "fieldTypeId": 12,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 12,
                      "fieldId": 73,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "OMBA-124 - Business Analytics",
                      "dbColumnName": "SubjectId",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "10816",
                      "fieldDataSourceType": "SubjectId",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "Label",
                      "fieldTypeId": 12,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 1,
              "sectionName": "Enrollment Information",
              "isActive": 0,
              "sequence": 1,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": []
          },
          {
              "sectionId": 9,
              "sectionName": "Correspondence Address",
              "isActive": 1,
              "sequence": 1,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 3,
              "fieldsList": [
                  {
                      "sectionId": 9,
                      "fieldId": 11,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Address Line 1",
                      "dbColumnName": "AddressLine1",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Alphanumeric"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "100"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 9,
                      "fieldId": 12,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Address Line 2",
                      "dbColumnName": "AddressLine2",
                      "isActive": 0,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "Txt",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 9,
                      "fieldId": 26,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Country",
                      "dbColumnName": "CountryId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "api/Admission/GetDataList?DataKey=country",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 3,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 9,
                      "fieldId": 27,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "State",
                      "dbColumnName": "StateId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "api/Admission/GetDataList?DataKey=state",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 4,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 9,
                      "fieldId": 28,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "City",
                      "dbColumnName": "CityId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "api/Admission/GetDataList?DataKey=city",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 5,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 9,
                      "fieldId": 29,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Pincode",
                      "dbColumnName": "Pincode",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "Txt",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "6"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 6,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 13,
              "sectionName": "Optional Subjects",
              "isActive": 0,
              "sequence": 2,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 11,
              "fieldsList": []
          },
          {
              "sectionId": 2,
              "sectionName": "Personal Information",
              "isActive": 1,
              "sequence": 2,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 2,
                      "fieldId": 1,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Full Name",
                      "dbColumnName": "Firstname",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "U",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "100"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 5,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Father Name",
                      "dbColumnName": "FatherName",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "30"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 7,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 7,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Gender",
                      "dbColumnName": "Gender",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "M=Male+F=Female+T=Transgender+O=Others",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 8,
                      "multipleSequence": 0,
                      "fieldType": "RadioButton",
                      "fieldTypeId": 3,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 8,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "DOB",
                      "dbColumnName": "DOB",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 5,
                      "multipleSequence": 0,
                      "fieldType": "Date",
                      "fieldTypeId": 6,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 9,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Mobile No",
                      "dbColumnName": "MobileNo",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Numbers only"
                          },
                          {
                              "property": "MinLength",
                              "value": "10"
                          },
                          {
                              "property": "MaxLength",
                              "value": "10"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 3,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 10,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Emai lId",
                      "dbColumnName": "EmailId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Email"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "30"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 4,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 22,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Photo",
                      "dbColumnName": "Photo",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "FileType",
                              "value": ".jpg,.jpeg,.png"
                          },
                          {
                              "property": "MinSize",
                              "value": "15"
                          },
                          {
                              "property": "MinSizeUnit",
                              "value": "KB"
                          },
                          {
                              "property": "MaxSize",
                              "value": "1"
                          },
                          {
                              "property": "MaxSizeUnit",
                              "value": "MB"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "Image",
                      "fieldTypeId": 10,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": []
                  },
                  {
                      "sectionId": 2,
                      "fieldId": 51,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Working Status",
                      "dbColumnName": "WorkingStatus",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "Employed=Employed+Unemployed=Unemployed",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 6,
                      "multipleSequence": 0,
                      "fieldType": "RadioButton",
                      "fieldTypeId": 3,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 10,
              "sectionName": "Permanent Address",
              "isActive": 1,
              "sequence": 2,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 3,
              "fieldsList": [
                  {
                      "sectionId": 10,
                      "fieldId": 13,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Permenant Address Line 1",
                      "dbColumnName": "PAddressLine1",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Alphanumeric"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "100"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 10,
                      "fieldId": 14,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Permenant Address Line 2",
                      "dbColumnName": "PAddressLine2",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Alphanumeric"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "100"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 10,
                      "fieldId": 42,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Permenant Country",
                      "dbColumnName": "PCountryId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "api/Admission/GetDataList?DataKey=country",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 3,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 10,
                      "fieldId": 43,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Permenant State",
                      "dbColumnName": "PStateId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "api/Admission/GetDataList?DataKey=state",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 4,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 10,
                      "fieldId": 44,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Permenant City",
                      "dbColumnName": "PCityId",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "api/Admission/GetDataList?DataKey=city",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 5,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 10,
                      "fieldId": 45,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Permenant Pincode",
                      "dbColumnName": "PPincode",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Numbers only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "6"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 6,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 3,
              "sectionName": "Communication Information",
              "isActive": 1,
              "sequence": 3,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 3,
                      "fieldId": 61,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "",
                      "dbColumnName": "C10",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;lt;span style=&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;quot;font-family: MyFont; font-size: 18.432px; background-color: rgb(255, 255, 255);&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;quot;&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;gt;&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;lt;font color=&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;quot;#000000&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;quot; style=&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;quot;&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;quot;&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;gt;Digivarsity, known as &amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;apos;The University of Work&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;apos;, revolutionizes education by embedding work directly into the learning journey. This approach ensures that students graduate not just with academic qualification but with real WORK experience, making them immediately valuable in the professional sphere.&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;lt;/font&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;gt;&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;lt;/span&amp;amp;amp;amp;amp;amp;amp;amp;amp;amp;gt;",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Paragraph",
                      "fieldTypeId": 14,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 1,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 5,
              "sectionName": "Education Detail",
              "isActive": 1,
              "sequence": 4,
              "isMultipleFields": 1,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 5,
                      "fieldId": 30,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Exam Name",
                      "dbColumnName": "ExamName",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "30"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 33,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Name of Board/University",
                      "dbColumnName": "University",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "30"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 3,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 34,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Subject Studied",
                      "dbColumnName": "SubjectStudied",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "30"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 4,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 35,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Result",
                      "dbColumnName": "Result",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "Pass=Pass+Failed=Failed",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 7,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 36,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Highest Qualification",
                      "dbColumnName": "IsHighest",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "1=Yes+0=No",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 8,
                      "multipleSequence": 0,
                      "fieldType": "RadioButton",
                      "fieldTypeId": 3,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 37,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Marks Obtained",
                      "dbColumnName": "marks_obtained",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Numbers only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "3"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 5,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 38,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Max Marks",
                      "dbColumnName": "max_marks",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Text only"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "6"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 6,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 5,
                      "fieldId": 40,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Exam Type",
                      "dbColumnName": "ExamType",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "SSC=SSC+HSC=HSC+UG=UG+PG=PG",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 6,
              "sectionName": "Work Experience",
              "isActive": 1,
              "sequence": 5,
              "isMultipleFields": 1,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 6,
                      "fieldId": 46,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Company Name",
                      "dbColumnName": "CompanyName",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "InputType",
                              "value": "Alphanumeric"
                          },
                          {
                              "property": "MinLength",
                              "value": "1"
                          },
                          {
                              "property": "MaxLength",
                              "value": "30"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Text",
                      "fieldTypeId": 1,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 6,
                      "fieldId": 47,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Office Address",
                      "dbColumnName": "OffAddress",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 3,
                      "multipleSequence": 0,
                      "fieldType": "TextArea",
                      "fieldTypeId": 7,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 6,
                      "fieldId": 48,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Currently Working",
                      "dbColumnName": "IsCurrentWorking",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "Y=Yes+N=No",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "RadioButton",
                      "fieldTypeId": 3,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 6,
                      "fieldId": 49,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Date of Joining",
                      "dbColumnName": "DOJ",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 4,
                      "multipleSequence": 0,
                      "fieldType": "Date",
                      "fieldTypeId": 6,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 6,
                      "fieldId": 50,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Date of Leaving",
                      "dbColumnName": "DOL",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 5,
                      "multipleSequence": 0,
                      "fieldType": "Date",
                      "fieldTypeId": 6,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 4,
              "sectionName": "Upload Document List",
              "isActive": 1,
              "sequence": 6,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 4,
                      "fieldId": 54,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "10th Mark Sheet (Self attested)",
                      "dbColumnName": "DocumentPath",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "455",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "FileType",
                              "value": ".jpg,.jpeg,.png"
                          },
                          {
                              "property": "MinSize",
                              "value": "30"
                          },
                          {
                              "property": "MinSizeUnit",
                              "value": "KB"
                          },
                          {
                              "property": "MaxSize",
                              "value": "1"
                          },
                          {
                              "property": "MaxSizeUnit",
                              "value": "MB"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "File",
                      "fieldTypeId": 9,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": []
                  },
                  {
                      "sectionId": 4,
                      "fieldId": 54,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "12th Mark Sheet (Mandatory for UG &amp;amp;amp;amp;amp;amp;amp;PG Course)",
                      "dbColumnName": "DocumentPath",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "456",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "FileType",
                              "value": ".jpg,.jpeg,.png"
                          },
                          {
                              "property": "MinSize",
                              "value": "30"
                          },
                          {
                              "property": "MinSizeUnit",
                              "value": "KB"
                          },
                          {
                              "property": "MaxSize",
                              "value": "1"
                          },
                          {
                              "property": "MaxSizeUnit",
                              "value": "MB"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "File",
                      "fieldTypeId": 9,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": []
                  }
              ]
          },
          {
              "sectionId": 15,
              "sectionName": "Test Custom Section",
              "isActive": 1,
              "sequence": 7,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 15,
                      "fieldId": 62,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "I am  Graduate from Shivaji University, Kolhapur",
                      "dbColumnName": "C11",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "1=Yes+2=No",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "RadioButton",
                      "fieldTypeId": 3,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 15,
                      "fieldId": 63,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "I am existing/former academic/administrative employee of Shivaji University, Kolhapur/Its affiliated  colleges",
                      "dbColumnName": "C12",
                      "isActive": 1,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "1=Yes+2=No",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 3,
                      "multipleSequence": 0,
                      "fieldType": "RadioButton",
                      "fieldTypeId": 3,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  },
                  {
                      "sectionId": 15,
                      "fieldId": 54,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "(Upload your Shivaji University degree certificate/Final year degree marklist)",
                      "dbColumnName": "DocumentPath",
                      "isActive": 0,
                      "isRequired": 1,
                      "inputCase": "",
                      "fieldDataSource": "656",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 2,
                      "multipleSequence": 0,
                      "fieldType": "File",
                      "fieldTypeId": 9,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": [
                          {
                              "FieldId": 54,
                              "DocumentCodeId": 12,
                              "DocumentCode": "Other",
                              "Document": "(Upload your Shivaji University degree certificate/Final year degree marklist)",
                              "UniversityMandateroy": "N",
                              "CategoryMandateroy": null,
                              "IsActive": null,
                              "IsDependent": null,
                              "DependentFieldId": null,
                              "DependentFieldValue": null,
                              "DocumentId": "656"
                          }
                      ]
                  },
                  {
                      "sectionId": 15,
                      "fieldId": 54,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "(Upload Letter from Competant authority of Shivaji University, Kolhapur/Its affiliated colleges)",
                      "dbColumnName": "DocumentPath",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "659",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [
                          {
                              "property": "FileType",
                              "value": ".jpg,.jpeg,.png"
                          },
                          {
                              "property": "MinSize",
                              "value": "30"
                          },
                          {
                              "property": "MinSizeUnit",
                              "value": "KB"
                          },
                          {
                              "property": "MaxSize",
                              "value": "1"
                          },
                          {
                              "property": "MaxSizeUnit",
                              "value": "MB"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 4,
                      "multipleSequence": 0,
                      "fieldType": "File",
                      "fieldTypeId": 9,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": [
                          {
                              "FieldId": 54,
                              "DocumentCodeId": 13,
                              "DocumentCode": "Other",
                              "Document": "(Upload Letter from Competant authority of Shivaji University, Kolhapur/Its affiliated colleges)",
                              "UniversityMandateroy": "N",
                              "CategoryMandateroy": null,
                              "IsActive": null,
                              "IsDependent": null,
                              "DependentFieldId": null,
                              "DependentFieldValue": null,
                              "DocumentId": "659"
                          }
                      ]
                  }
              ]
          },
          {
              "sectionId": 16,
              "sectionName": "Custom Section 2",
              "isActive": 0,
              "sequence": 8,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": []
          },
          {
              "sectionId": 17,
              "sectionName": "Custom Section 3",
              "isActive": 0,
              "sequence": 9,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": []
          },
          {
              "sectionId": 7,
              "sectionName": "Annexure Details",
              "isActive": 1,
              "sequence": 10,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 7,
                      "fieldId": 52,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "",
                      "fieldName": "Interested In",
                      "dbColumnName": "Interested_In",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "1=OJT with Stipend+2=Digital Internship+3=Auto Placed",
                      "fieldDataSourceType": "TXT",
                      "fieldValidations": [],
                      "fieldDependencies": [],
                      "helpText": "",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "DropDown",
                      "fieldTypeId": 2,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": null,
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          },
          {
              "sectionId": 11,
              "sectionName": "Subject Details",
              "isActive": 1,
              "sequence": 11,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": []
          },
          {
              "sectionId": 14,
              "sectionName": "Opportunity Selection",
              "isActive": 1,
              "sequence": 12,
              "isMultipleFields": 0,
              "unvId": 99,
              "categoryId": 334,
              "parentSectionId": 0,
              "fieldsList": [
                  {
                      "sectionId": 14,
                      "fieldId": 74,
                      "fieldRefTypeId": 0,
                      "fieldRefType": "JobId",
                      "fieldName": "Opportunity",
                      "dbColumnName": "",
                      "isActive": 1,
                      "isRequired": 0,
                      "inputCase": "",
                      "fieldDataSource": "",
                      "fieldDataSourceType": "API",
                      "fieldValidations": [
                          {
                              "property": "MinSelections",
                              "value": "1"
                          },
                          {
                              "property": "MaxSelections",
                              "value": "5"
                          }
                      ],
                      "fieldDependencies": [],
                      "helpText": "Please select at least 1 and a maximum of 5 opportunity cards",
                      "sequence": 1,
                      "multipleSequence": 0,
                      "fieldType": "Card",
                      "fieldTypeId": 13,
                      "maxLength": 0,
                      "validationType": "",
                      "validationTypeId": 0,
                      "isPrint": 0,
                      "value": "",
                      "valueLabel": "",
                      "visibleToStudent": "1",
                      "documentProperties": {}
                  }
              ]
          }
      ],
      "universityFlags": [
          {
              "Key": "AadhaarEnabled",
              "Value": 1
          },
          {
              "Key": "FullNameApplicable",
              "Value": 1
          },
          {
              "Key": "IsInternational",
              "Value": 0
          },
          {
              "Key": "ExamDetailMandatory",
              "Value": 1
          },
          {
              "Key": "AadhaarKYCEnabled",
              "Value": 1
          },
          {
              "Key": "DEBEnabled",
              "Value": 0
          },
          {
              "Key": "AdmissionAuthentication",
              "Value": 1
          }
      ],
      "fieldDepedancyList": [
          {
            "sectionId": "2",
            "fieldId": "51",
            "value": "",
            "fieldDepedancies": [
                {
                    "sectionId": "2",
                    "fieldId": "5",
                    "fieldRefId": "",
                    "dependancyType": "7", // disable
                    "value": "Unemployed"
                }
            ]
          },
          {
            "sectionId": "2",
            "fieldId": "51",
            "value": "",
            "fieldDepedancies": [
                {
                    "sectionId": "2",
                    "fieldId": "5",
                    "fieldRefId": "",
                    "dependancyType": "5", // disable
                    "value": "Unemployed"
                }
            ]
          },
          {
              "sectionId": "2",
              "fieldId": "51",
              "value": "",
              "fieldDepedancies": [
                  {
                      "sectionId": "2",
                      "fieldId": "5",
                      "fieldRefId": "",
                      "dependancyType": "2",
                      "value": "Unemployed"
                  }
              ]
          },
          {
              "sectionId": "5",
              "fieldId": "36",
              "value": "",
              "fieldDepedancies": [
                  {
                      "sectionId": "5",
                      "fieldId": "36",
                      "fieldRefId": "",
                      "dependancyType": "4",
                      "value": "1"
                  }
              ]
          },
          {
              "sectionId": "6",
              "fieldId": "48",
              "value": "",
              "fieldDepedancies": [
                  {
                      "sectionId": "6",
                      "fieldId": "47",
                      "fieldRefId": "",
                      "dependancyType": "2",
                      "value": "Y"
                  }
              ]
          },
          {
              "sectionId": "15",
              "fieldId": "63",
              "value": "",
              "fieldDepedancies": [
                  {
                      "sectionId": "15",
                      "fieldId": "54",
                      "fieldRefId": "659",
                      "dependancyType": "2",
                      "value": "1"
                  }
              ]
          }
      ]
  },
  "message": "Success",
  "lastCachedAt": null,
  "cachedTill": null
}